<template>
  <div class="sync-wrapper">
    <div v-for="(mailingList, key) in companyMailingLists" :key="key">
      <h3>{{ mailingList.name }}</h3>
      <data-input
        :value="contactPartnerInMailingList[key]"
        label="in Liste"
        name="sync"
        type="bool"
        @input="() => updateCleverreachState(key)"
      />
      <div v-if="updatingMailingList[key]" class="loading-animation">
        <i class="fad fa-spinner-third"></i>
      </div>
      <table>
        <tr>
          <th>Zuletzt Geändert:</th>
          <td>{{ timeFromTimestamp(mailingList.lastChanged) }}</td>
        </tr>
        <tr>
          <th>Letzte Mail:</th>
          <td>{{ timeFromTimestamp(mailingList.lastMailing) }}</td>
        </tr>
        <template v-if="contactPartnerInMailingList[key]">
          <tr>
            <th>Abgelehnte Emails</th>
            <td>{{ localStatus[key].bounced }}</td>
          </tr>
          <tr v-if="localStatus[key].activated <= localStatus[key].deactivated">
            <th><i class="fas fa-times"></i>Inaktiv seit:</th>
            <td>{{ timeFromTimestamp(localStatus[key].deactivated) }}</td>
          </tr>
          <tr v-else>
            <th><i class="fas fa-check"></i>Aktiv seit:</th>
            <td>{{ timeFromTimestamp(localStatus[key].activated) }}</td>
          </tr>
          <tr>
            <th>click rate</th>
            <td>{{ localStatus[key].clickRate }}</td>
          </tr>
          <tr>
            <th>conversion rate</th>
            <td>{{ localStatus[key].converisonRate }}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{ localStatus[key].email }}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: ["companyContactID"],
  data() {
    return {
      companyMailingLists: [],
      contactPartnerInMailingList: [],
      updatingMailingList: [],
      localStatus: [],
      updatingValue: {}
    };
  },
  apollo: {
    companyMailingLists: {
      query: gql`
        query CompanyMailingLists {
          companyMailingLists {
            id
            name
            cleverreachID
            stamp
            lastChanged
            lastMailing
          }
        }
      `
    },
    companyContactCleverreachStatus: {
      query: gql`
        query CompanyContactCleverreachStatus($companyContactID: ID!) {
          companyContactCleverreachStatus(companyContactID: $companyContactID) {
            id
            email
            imported
            bounced
            groupID
            activated
            registered
            deactivated
            lastIP
            lastLocation
            lastClient
            points
            stars
            source
            attributes
            globalAttributes
            active
            converisonRate
            openRate
            clickRate
            tags
          }
        }
      `,
      variables() {
        return {
          companyContactID: this.companyContactID
        };
      },
      fetchPolicy: "no-cache"
    }
  },
  watch: {
    companyMailingLists: {
      deep: true,
      immididate: true,
      handler(value) {
        this.doUpdate(value);
      }
    },
    companyContactCleverreachStatus: {
      deep: true,
      immididate: true,
      handler() {
        this.doUpdate(this.companyMailingLists);
      }
    }
  },

  methods: {
    timeFromTimestamp(stamp) {
      if (stamp != 0) {
        return new Date(stamp * 1000).toLocaleString();
      }
      return "Nie";
    },
    doUpdate(value) {
      if (!value) {
        return;
      }
      this.contactPartnerInMailingList = new Array(value.length);
      this.localStatus = new Array(value.length);
      for (let i = 0; i < value.length; i++) {
        this.contactPartnerInMailingList[i] = (() => {
          let result = false;
          for (const stat of this.companyContactCleverreachStatus || []) {
            if (stat.groupID && stat.groupID == value[i].cleverreachID) {
              return true;
            }
          }
          return result;
        })();
        this.localStatus[i] = (() => {
          for (const stat of this.companyContactCleverreachStatus || []) {
            if (stat.groupID && stat.groupID == value[i].cleverreachID) {
              return stat;
            }
          }
          return {};
        })();
      }
    },
    async updateCleverreachState(i) {
      let value = !this.contactPartnerInMailingList[i];
      this.updatingMailingList[i] = true;

      if (value) {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($companyContactID: ID!, $mailingListId: String!) {
              addContactPartnerToMailingList(
                contactPartnerID: $companyContactID
                mailingListId: $mailingListId
              ) {
                id
              }
            }
          `,
          variables: {
            companyContactID: this.companyContactID,
            mailingListId: this.companyMailingLists[i].id
          }
        });
        await this.$apollo.queries.companyContactCleverreachStatus.refetch();
        this.doUpdate(this.companyMailingLists);
        this.updatingMailingList[i] = false;
      } else {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($companyContactID: ID!, $mailingListId: String!) {
              removeContactPartnerFromMailingList(
                contactPartnerID: $companyContactID
                mailingListId: $mailingListId
              )
            }
          `,
          variables: {
            companyContactID: this.companyContactID,
            mailingListId: this.companyMailingLists[i].id
          }
        });
        await this.$apollo.queries.companyContactCleverreachStatus.refetch();
        this.doUpdate(this.companyMailingLists);
        this.updatingMailingList[i] = false;
      }
    }
  }
};
</script>
<style scoped>
.sync-wrapper {
  display: grid;
  gap: 4rem;
  grid-template-columns: repeat(auto-fit, minmax(35ch, 1fr));
}
.loading-animation > * {
  display: inline-block !important;
  animation: rotate 1s linear 0s infinite;
}
.loading-animation {
  display: inline-block;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
